import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Product } from '@schoolbelle/api/purchase';
import { SelectAbstractComponent, ProductParams } from '../select-abstract';
import { FormGroup } from '@angular/forms';
import { PurchaseService } from '@schoolbelle/api/purchase';

@Component({
  selector: 'app-select-crawl',
  templateUrl: './select-crawl.component.html',
  styleUrls: ['./select-crawl.component.css'],
  changeDetection:ChangeDetectionStrategy.OnPush,
})
export class SelectCrawlComponent extends SelectAbstractComponent implements OnInit {
  @Input() form:FormGroup;
  @Input() required:boolean = false;
  @Input() products:ProductParams[] = [];
  @Output() productsChange = new EventEmitter<ProductParams[]>();

  crawl:Product;
  constructor (
    purchase:PurchaseService,
  ) {
    super(purchase);
  }
  ngOnInit(): void {
    this.setProducts();
    super.ngOnInit();
    this.setIndex();
  }
  onUpdate (index:number) {
    let products:ProductParams[] = [];
    if (typeof index === 'number') {
      products.push({productId:55, quantity:index + 1});
    } 
    this.products = products;
    this.productsChange.next(this.products);    

  }
  protected setIndex () {
    const crawl = this.products[0];
    if (crawl) {
      this.indexCtrl.setValue(crawl.quantity - 1)
    }
  }

  protected setProducts () {
    this.crawl = this.purchase.currentProducts.find(product=>{
      return [55].includes(product.product_id);
    });
  }


}
